import { useEffect, useState } from 'react';
import { fetchJson } from '../../utils';
import styles from './settings.module.scss';
import { useNavigate } from 'react-router';



const CONFIRMATION_TEXT = 'DeletE AccounT';

export const AccountSettings = () => {
    const [isDeleting, setIsDeleting] = useState(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [deleteInputText, setDeleteInputText] = useState('');
    const navigate = useNavigate();
    useEffect(() => {
        if (deleteInputText === CONFIRMATION_TEXT) {
            deleteAccount();
        }
    }, [deleteInputText]);

    const deleteAccount = async () => {
        try {
            setIsDeleting(true);
            const {json} = await fetchJson<{success: boolean, message?: string}>('/api/account/delete', {
                method: 'POST',
                body: JSON.stringify({
                    password: deleteInputText
                })
            });

            if (json && 'success' in json && json.success) {
                // Redirect to home page or login page after successful deletion
                navigate('/');
            } else {
                alert((json && 'message' in json && json.message) || 'Failed to delete account. Please try again.');
            }
        } catch (error) {
            alert('An error occurred while deleting your account. Please try again.');
        } finally {
            setIsDeleting(false);
            setShowConfirmDialog(false);
            setDeleteInputText('');
        }
    };

    const handleDeleteInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Only allow keyboard input, one character at a time
        if (value.length <= CONFIRMATION_TEXT.length && value.length <= deleteInputText.length + 1) {
            setDeleteInputText(value);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        // Prevent copy/paste shortcuts
        if ((e.ctrlKey || e.metaKey) && (e.key === 'v' || e.key === 'V')) {
            e.preventDefault();
        }
    };

    const handlePaste = (e: React.ClipboardEvent) => {
        e.preventDefault();
    };

    return (
        <div className={styles.accountSection}>
            <h1 className="section__title">Account Settings</h1>
            <div className={styles.accountSectionContent}>
                {!showConfirmDialog && !isDeleting && (
                    <button
                        className={`btn btn_lg btn_extrapad ${styles.btn}`}
                        onClick={() => setShowConfirmDialog(true)}
                        disabled={isDeleting}
                    >
                        {isDeleting ? 'Deleting...' : 'Delete Account'}
                    </button>
                )}

                {showConfirmDialog && (
                    <div className={styles.confirmDialog}>
                        <p>Upon deleting your account, all your information will be removed, including photos and completed videos.</p>
                        <p>This action cannot be undone, and the account will not be recoverable.</p>
                        <p>
                            Please type exactly: <strong>{CONFIRMATION_TEXT}</strong> to confirm account deletion.
                        </p>
                        
                        <div className="form__row">
                            <div className="form__input-holder">
                                <input
                                    type="text"
                                    disabled={isDeleting}
                                    className={`form__input`}
                                    value={deleteInputText}
                                    onChange={handleDeleteInputChange}
                                    onKeyDown={handleKeyDown}
                                    onPaste={handlePaste}
                                    placeholder="Type to confirm"
                                    autoComplete="off"
                                    autoCapitalize="off"
                                    autoCorrect="off"
                                    spellCheck={false}
                                    maxLength={CONFIRMATION_TEXT.length}
                                    aria-label="Delete account confirmation input"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AccountSettings; 